export default {
  APPRECIATION_LIST: 'resource-appreciation.list',
  APPRECIATION_EDIT: 'resource-appreciation.edit',
  APPRECIATION_PUBLISH: 'resource-appreciation.publish',
  APPRECIATION_DELETE: 'resource-appreciation.delete',
  APPRECIATION_CONFIG: 'resource-appreciation.config'
}
